"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const transformToken = (name, token) => [
    {
        name,
        tokenType: "zIndex",
        type: "variable",
        value: `${token.level}`,
    },
];
exports.default = transformToken;
